export default __webpack_public_path__ + "static/media/help-rav-qa-10.65d57623.png";